import type { ArsColorCode } from '../../types/barDiagram';

/** Mapa de ArsColorCode → CSS inline style (extraído del CSS de ARS_93) */
export const arsColorStyles: Record<ArsColorCode, React.CSSProperties> = {
  'p0': { backgroundColor: 'black' },
  'p1': { backgroundColor: 'lawngreen' },
  'p2': { backgroundColor: 'gold' },
  'p3': { backgroundColor: 'red' },
  'p4': {
    backgroundImage: 'linear-gradient(180deg, lawngreen 50%, gold 50%)',
    backgroundSize: '100% 100%',
  },
  'p5': {
    backgroundImage: 'linear-gradient(180deg, red 50%, gold 50%)',
    backgroundSize: '100% 100%',
  },
  'p6': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, lawngreen 50%, transparent 50%), linear-gradient(90deg, gold 50%, transparent 50%)',
    backgroundSize: '100% 100%',
  },
  'p7': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, gold 50%, transparent 50%), linear-gradient(90deg, lawngreen 50%, transparent 50%)',
    backgroundSize: '50% 100%',
  },
  'p8': {
    backgroundImage: 'linear-gradient(90deg, gold 50%, white 50%)',
    backgroundSize: '100% 100%',
  },
  'p9': {
    backgroundImage: 'linear-gradient(90deg, lawngreen 50%, white 50%)',
    backgroundSize: '100% 100%',
  },
  'p10': {
    backgroundImage: 'linear-gradient(90deg, lawngreen 50%, white 50%)',
    backgroundSize: '50% 50%',
  },
  'p11': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, red 50%, transparent 50%), linear-gradient(90deg, gold 50%, transparent 50%)',
    backgroundSize: '100% 100%',
  },
  'p14': {
    backgroundImage: 'linear-gradient(90deg, red 50%, white 50%)',
    backgroundSize: '100% 100%',
  },
  'p15': {
    backgroundImage: 'linear-gradient(90deg, red 50%, white 50%)',
    backgroundSize: '50% 50%',
  },
  'p16': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, gold 75%, transparent 50%), linear-gradient(45deg, lawngreen 5%, transparent 25%)',
    backgroundSize: '50% 100%',
  },
  'p22': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, gold 50%, transparent 50%), linear-gradient(90deg, lawngreen 50%, transparent 50%)',
    backgroundSize: '25% 100%',
  },
  'p39': {
    backgroundColor: 'white',
    backgroundImage:
      'linear-gradient(180deg, gold 50%, transparent 50%), linear-gradient(90deg, red 50%, transparent 50%)',
    backgroundSize: '50% 100%',
  },
  '-': { backgroundColor: 'transparent' },
};

/** Descripción legible de cada código de color */
export const arsColorLabels: Record<ArsColorCode, string> = {
  'p0': 'D — Apagat',
  'p1': 'V — Verd',
  'p2': 'A — Ambre',
  'p3': 'R — Vermell',
  'p4': 'N — Verd / Ambre',
  'p5': 'S — Ambre / Vermell',
  'p6': 'J — Verd / Ambre interm. lent',
  'p7': 'I — Verd interm. ràpid / Ambre interm. lent',
  'p8': 'F — Ambre intermitent (lent)',
  'p9': 'C — Verd intermitent (lent)',
  'p10': 'P — Verd intermitent (ràpid)',
  'p11': 'G — Ambre interm. lent / Vermell',
  'p14': 'B — Vermell intermitent (lent)',
  'p15': 'H — Vermell intermitent (ràpid)',
  'p16': 'K — Verd interm. / Ambre interm. (lents alternats)',
  'p22': 'E — Verd interm. ràpid / Ambre interm. ràpid',
  'p39': 'Z — Ambre interm. / Vermell interm. (lents alternats)',
  '-': 'Sense ús',
};
